// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1493":"df5d8f41","2487":"83da9c46","2970":"83da9c46","4355":"df5d8f41","4919":"d25caddb","8241":"732a1860","9389":"d25caddb","9544":"df5d8f41"}[chunkId] + ".chunk.css";
};